var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFactory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.279 2.16949C12.0999 2.09772 11.9001 2.09772 11.721 2.16949L2.769 5.74999L6.375 7.19149L15.606 3.49999L12.279 2.16949ZM17.625 4.30849L8.394 7.99999L12 9.44149L21.231 5.74999L17.625 4.30849ZM22.5 6.85849L12.75 10.7585V22.6415L22.5 18.7415V6.85849ZM11.25 22.643V10.757L1.5 6.85849V18.743L11.25 22.643ZM11.1645 0.775988C11.7008 0.561487 12.2992 0.561487 12.8355 0.775988L23.529 5.05399C23.668 5.10971 23.7872 5.20578 23.8711 5.32982C23.9551 5.45387 24 5.60021 24 5.74999V18.743C23.9998 19.0427 23.9098 19.3355 23.7417 19.5836C23.5735 19.8317 23.3348 20.0238 23.0565 20.135L12.279 24.446C12.0999 24.5178 11.9001 24.5178 11.721 24.446L0.945 20.135C0.666377 20.024 0.427414 19.8321 0.258963 19.584C0.0905126 19.3358 0.000309494 19.0429 0 18.743L0 5.74999C3.48599e-05 5.60021 0.0449156 5.45387 0.128861 5.32982C0.212805 5.20578 0.331969 5.10971 0.471 5.05399L11.1645 0.775988Z",
    fill: "#ADADAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactory);
export default __webpack_public_path__ + "static/media/factory.dab43985549e61fab44f6bd3033da7b5.svg";
export { ForwardRef as ReactComponent };